module.exports = __webpack_public_path__ + "static/media/tick.138df736.png";